import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import "./Calculator.css";
import Button from "react-bootstrap/Button";

function Calculator() {
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [content, setContent] = useState(<></>);

  const calculateSampleSize = (totalEmployees) => {
    if (totalEmployees <= 50) {
      setContent(
        <>
          <p>
            Se recomienda evaluar a todos los colaboradores y utilizar los
            cuestionarios de:
            <ul>
              <li>ACONTECIMIENTOS TRAUMÁTICOS</li>
              <li>FACTORES DE RIESGO PSICOSOCIAL</li>
            </ul>
          </p>
        </>
      );
    } else if (totalEmployees > 50) {
      let size = Math.ceil(
        (0.9604 * totalEmployees) / (0.0025 * (totalEmployees - 1) + 0.9604)
      );

      setContent(
        <>
          <p>
            Se recomienda evaluar a <strong>{size} colaboradores</strong> y
            utilizar los cuestionarios de:
            <ul>
              <li>ACONTECIMIENTOS TRAUMÁTICOS</li>
              <li>
                FACTORES DE RIESGO PSICOSOCIAL Y EVALUACIÓN DEL ENTORNO
                ORGANIZACIONAL
              </li>
            </ul>
          </p>
        </>
      );
    }
  };

  const handleTotalEmployeesChange = (e) => {
    const value = parseInt(e.target.value, 10);
    setTotalEmployees(value);
  };

  return (
    <Container fluid>
      <Row className="mb-3">
        <Col className="calculator">
          <Form>
            <Form.Group className="mb-1">
              <Form.Label>Colaboradores totales de la organización</Form.Label>
              <Form.Control
                type="number"
                onChange={(e) => handleTotalEmployeesChange(e)}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Button
                className="primary"
                onClick={() => calculateSampleSize(totalEmployees)}
              >
                Recomendar
              </Button>
            </Form.Group>
          </Form>
          <p>{content}</p>
        </Col>
      </Row>
    </Container>
  );
}

export default Calculator;
